import Vue from 'vue';
import Router from 'vue-router';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';
import Connexion from '@/components/Connexion';
import Mdp from '@/components/Mdp';
import Accueil from '@/components/Accueil';
import AccueilCoach from '@/components/AccueilCoach';
import Questionnaire from '@/components/Questionnaire';
import SessionCollective from '@/components/SessionCollective';
import SessionIndiv from '@/components/SessionIndiv';
import Statistiques from '@/components/Statistiques';
import Test from '@/components/Test';
import ExercicesFavories from '@/components/ExercicesFavories';
import Cours from '@/components/Cours';
import Indicateur from '@/components/Indicateur';
import Circle_loader from '@/components/Circle-loader';



import { User } from "../controller/user.js";
import { VideoCollection } from '@/controller/Video.js';
import { hostUrl } from "../_helpers/global_var";


Vue.use(Router)

const router = new Router({
    mode: 'history',
})


export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Accueil',
            components: {
                default: Accueil,
                sidebar: Sidebar,
                header: Header,
            },
            beforeEnter: (to, from, next) => {
                if (from.path == '/connexion') {
                    let user = JSON.parse(localStorage.user);
                    const axios = require('axios').default;
                    async function loadLocal() {
                        await axios
                            .get(hostUrl + '/salarie/infoResultat/' + user.salarie_id)
                            .then(response => localStorage.resultats = JSON.stringify(response.data))
                            .catch(error => console.log(error));
                    }
                    loadLocal().then(function() {
                        if (typeof(localStorage.resultats) !== 'undefined' && localStorage.resultats !== '[]') {
                            return next();
                        } else {
                            return next('/test');
                        }
                    });
                } // fin if
                next();
            }, // fin before enter

        },
        {
            path: '/coach',
            name: 'Accueil_Coach',
            components: {
                default: AccueilCoach,
                sidebar: Sidebar,
                header: Header,
            },
        },
        {
            path: '/session_co',
            name: 'Session_Collective',
            components: {
                default: SessionCollective,
                sidebar: Sidebar,
                header: Header,
            },
            beforeEnter: (to, from, next) => {
                let user = JSON.parse(localStorage.user);
                const axios = require('axios').default;
                async function loadLocal() {
                    await axios
                        .get(hostUrl + '/allSalarie/' + user.nom_entreprise.toLowerCase())
                        .then(response => localStorage.listeSalarie = JSON.stringify(response.data))
                        .catch(error => console.log('ko = ' + error));
                }
                loadLocal().then(function() {
                    if (typeof(localStorage.listeSalarie) !== 'undefined') {
                        console.log('reussite');
                        next();
                    } else {
                        console.log('echec');
                    }
                });
            },
        },
        {
            path: '/session',
            name: 'Session_Individuelle',
            components: {
                default: SessionIndiv,
                sidebar: Sidebar,
                header: Header,
            },
            beforeEnter: (to, from, next) => {
                next();
                /*
                        let user = JSON.parse(localStorage.user);
                        const axios = require('axios').default;
                        async function loadLocal() {
                          let uri ="";
                          if (user.metier == null || user.niveau == null || user.salarie_id == null){
                            uri = hostUrl+'/all_video';
                          }else{
                            uri = hostUrl+'/protocole/'+user.metier +'/'+user.niveau+'/'+user.salarie_id;
                          }
                          await axios
                            .get(uri)
                            .then(response => localStorage.video = JSON.stringify(response.data))
                            .catch(error => console.log(error));
                          }
                        loadLocal().then(function(){
                          if (typeof(localStorage.video) !== 'undefined' ){
                          console.log('reussite');
                          next();
                        }else {
                          console.log('echec');
                        }
                        });*/
            },
        },
        {
            path: '/questionnaire',
            name: 'Questionnaire',
            components: {
                default: Questionnaire,
                sidebar: Sidebar,
                header: Header,
            },
        },
        {
            path: '/connexion',
            name: 'connexion',
            components: {
                default: Connexion,
                sidebar: Sidebar,
            },
        },
        {
            path: '/changement_mots_de_passe',
            name: 'Changement_Mdp',
            components: {
                default: Mdp,
                sidebar: Sidebar,
            },
        },
        {
            path: '/changement_mots_de_passe/:id',
            name: 'Changement_Mdp2',
            components: {
                default: Mdp,
                sidebar: Sidebar,
            },
        },
        {
            path: '/first_co/:id',
            name: 'Changement_Mdp3',
            components: {
                default: Mdp,
                sidebar: Sidebar,
            },
        },
        {
            path: '/statistiques',
            name: 'Statistiques',
            components: {
                default: Statistiques,
                sidebar: Sidebar,
                header: Header,
            },
            beforeEnter: (to, from, next) => {
                let user = JSON.parse(localStorage.user);
                const axios = require('axios').default;
                async function loadLocal() {
                    let uri = hostUrl + '/salarie/infoResultat/' + user.salarie_id;

                    await axios
                        .get(uri)
                        .then(response => localStorage.resultats = JSON.stringify(response.data))
                        .catch(error => console.log(error));
                }
                loadLocal().then(function() {
                    if (typeof(localStorage.resultats) !== 'undefined') {
                        console.log('reussite');
                        next();
                    } else {
                        console.log('echec');
                    }
                });
            },
        },
        {
            path: '/test',
            name: 'Test',
            components: {
                default: Test,
                sidebar: Sidebar,
                header: Header,
            },
        },
        {
            path: '/contre-indication',
            name: 'Indicateur',
            components: {
                default: Indicateur,
                sidebar: Sidebar,
                header: Header,
            },
        },
        {
            path: '/exercices_favories',
            name: 'Favories',
            components: {
                default: ExercicesFavories,
                sidebar: Sidebar,
                header: Header,
            },

        },
        {
            path: '/mes_cours',
            name: 'Cours',
            components: {
                default: Cours,
                sidebar: Sidebar,
                header: Header,
            },

        },
        {
            path: '/deconnexion',
            name: 'log-out',
            beforeEnter: (to, from, next) => {
                localStorage.clear();
                console.log('deco');
                next('/connexion');
            },
        },
        {
            path: '*',
            redirect: '/'
        }
    ],
});
router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page

    const publicPages = ['/connexion', '/changement_mots_de_passe', '/first_co'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');
    if (authRequired && !loggedIn) {

        for (let index = 0; index < publicPages.length - 1; index++) {
            const regex1 = /first_co/i;
            const regex2 = /changement_mots_de_passe/i;
            console.log(to.path.search(regex1));
            if (to.path.search(regex1) == 1) {
                return next();
            } else if (to.path.search(regex2) == 1) {
                return next();
            }
        }
        console.log('ko', to.path);
        return next('/connexion');
    }
    next();
})


// WEBPACK FOOTER //
// ./src/router/index.js